module.exports = __webpack_public_path__ + "static/img/illust_2_mk.ddfd4ea5.svg";